module.exports = __webpack_public_path__ + "img/credit.2395ce70.svg";